import { NavContainer, StorageVolumnBox } from "../../style/lauout/layout";
import menuData from "../../components/layout/menu.data.json";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuthStore } from "../../atoms/user.auth.store";
import { useEffect, useState } from "react";
import { fetchVolumeState, VolumeStateResponse } from "../../api/admin";
import ModalCenterLayout from "../modal/modal.center.layout";
import PasswordModify from "./modal/password.modify";
interface ModalProps {
  isOpen: boolean;
  isVisible: boolean;
}

const USER_MENU_PATHS = ["/backup", "/db", "/image"];

const formatStorageSize = (value: number) => {
  if (!Number.isFinite(value) || value <= 0) return "0 B";

  const units = ["B", "KB", "MB", "GB", "TB"];
  const unitIndex = Math.min(
    Math.floor(Math.log(value) / Math.log(1000)),
    units.length - 1,
  );
  const size = value / 1000 ** unitIndex;
  const formattedSize =
    size >= 10 || unitIndex === 0 ? Math.round(size) : Number(size.toFixed(1));

  return `${formattedSize} ${units[unitIndex]}`;
};

const NavMenu = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [volumeState, setVolumeState] = useState<VolumeStateResponse | null>(
    null,
  );
  const [volumeLoading, setVolumeLoading] = useState(false);
  const [volumeError, setVolumeError] = useState(false);

  const [modifyModal, setModifyModal] = useState<ModalProps>({
    isOpen: false,
    isVisible: false,
  });

  const currentPath = location.pathname;
  const { role, logout } = useAuthStore();

  const id = JSON.parse(localStorage.getItem("savedLoginInfo") || "{}")?.id;
  const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

  const userId = localStorage.getItem("userId");
  const isLoginPage = currentPath === "/login";
  const usedVolume = volumeState?.used ?? 0;
  const provisionedVolume = volumeState?.provisioned ?? 0;
  const usagePercent =
    provisionedVolume > 0
      ? Math.min((usedVolume / provisionedVolume) * 100, 100)
      : 0;

  const filteredMenu = menuData.filter((item) => {
    if (role === "admin") return true;
    if (role === "user") return USER_MENU_PATHS.includes(item.path);
    return false;
  });

  useEffect(() => {
    if (role !== "admin" || !userId) {
      setVolumeState(null);
      return;
    }

    const loadVolumeState = async () => {
      setVolumeLoading(true);
      setVolumeError(false);

      try {
        const response = await fetchVolumeState(userId);
        setVolumeState(response);
      } catch (err) {
        setVolumeError(true);
      } finally {
        setVolumeLoading(false);
      }
    };

    loadVolumeState();
  }, [role, userId]);

  const modifyModalClosed = () => {
    setModifyModal({ isOpen: false, isVisible: false });
  };
  const modifyModalOpened = () => {
    setModifyModal({ isOpen: true, isVisible: true });
  };

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <NavContainer>
      <div
        className="logo"
        onClick={() => {
          if (location.pathname === "/login") navigate("/");
        }}
        style={location.pathname === "/login" ? { cursor: "pointer" } : {}}
      >
        <span className="icon-box">
          {/* <img src="/assets/logo.png" alt="" /> */}
          <img src="/assets/new_design/logo_speedbackup_1.png" alt="" />
        </span>
        {/* <span className="img-box">
          <img src="/assets/logo_txt.png" alt="" />
        </span> */}
      </div>
      <ul>
        {filteredMenu.map((item) => {
          const isActive =
            currentPath === item.path ||
            currentPath.startsWith(item.path + "/");

          return (
            <li
              key={item.path}
              className={isActive ? "active" : ""}
              onClick={() => {
                if (role === "admin") {
                  navigate(item.move_path);
                } else if (role === "user" && userId) {
                  navigate(`${item.path}/device/${userId}`);
                }
              }}
            >
              <div className="item-box">
                <div className="icon-box">
                  {isActive ? (
                    <img src={item.active_icon} alt={item.name} />
                  ) : (
                    <img src={item.icon} alt={item.name} />
                  )}
                </div>
                <span>{item.name}</span>
              </div>
            </li>
          );
        })}
      </ul>
      {!isLoginPage && (
        <div className="nav-footer">
          <div>
            <p className="company-name">{userInfo.companyName}</p>
          </div>
          <div className="user-info">
            <span>
              <b>{id}</b> 님
            </span>
            {role === "user" && (
              <button type="button" onClick={modifyModalOpened}>
                정보변경
              </button>
            )}
          </div>
          {role === "admin" && (
            <StorageVolumnBox>
              <div className="inner">
                <div className="storage-title">스토리지 사용량</div>
                <div className="storage-volume">
                  {volumeLoading ? (
                    "불러오는 중..."
                  ) : volumeError ? (
                    "조회 실패"
                  ) : (
                    <>
                      <span>{formatStorageSize(usedVolume)}</span>
                      <span className="divider">/</span>
                      <span>{formatStorageSize(provisionedVolume)}</span>
                    </>
                  )}
                </div>
                <div className="storage-progress" aria-hidden="true">
                  <div
                    className="storage-progress-bar"
                    style={{ width: `${usagePercent}%` }}
                  />
                </div>
                {!volumeLoading && !volumeError && (
                  <div className="storage-percent">
                    {usagePercent.toFixed(1)}%
                  </div>
                )}
              </div>
            </StorageVolumnBox>
          )}
          <button
            type="button"
            className="logout-button"
            onClick={handleLogout}
          >
            <span>
              <img src="/assets/new_design/logout.png" alt="" />
            </span>
            로그아웃
          </button>
        </div>
      )}

      {modifyModal.isOpen && (
        <ModalCenterLayout
          isVisible={modifyModal.isVisible}
          closedHandler={modifyModalClosed}
        >
          <PasswordModify closedHandler={modifyModalClosed} />
        </ModalCenterLayout>
      )}
    </NavContainer>
  );
};

export default NavMenu;
